
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-label',
    label: '監護人姓名',
    model: 'parent_name',
    fieldClasses: 'bold',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-label',
    label: '監護人病歷號',
    model: 'parent_patient_no',
    fieldClasses: 'bold',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-label',
    label: '寶寶姓名',
    model: 'baby_name',
    fieldClasses: 'bold',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-label',
    label: '寶寶病歷號',
    model: 'baby_patient_no',
    fieldClasses: 'bold',
    visible: (model) => model.id,
  },
  {
    type: "bsx-select",
    label: "綁定來源",
    model: "binding_type",
    disabled: true,
    visible: (model) => model.id,
    values: [
      { id: "APP", name: "APP" },
      { id: "BACKSTAGE", name: "BSX 後台" },
    ],
  },
  {
    type: "x-buttonRemoveParentBabyBinding",
    visible: (model) => model.id,
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '監護人病歷號',
    model: 'parent_patient_no',
    placeholder: '監護人病歷號',
    required: true,
    visible: (model) => !model.id,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '寶寶病歷號',
    model: 'baby_patient_no',
    placeholder: '寶寶病歷號',
    required: true,
    visible: (model) => !model.id,
    validator: function () {
      this.validation();
    },
  }
];

export default fields;
